import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'react-bootstrap';
import SmashSpinner from '../../../components/SmashSpinner/SmashSpinner';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { deleteKey, listApiKeys, apiKeyState, resetDeletedKey } from '../apiKeySlice';


interface Props {
    children?: React.ReactNode;
    item?: any; // FIXME Type ?
}
const ConfirmDeleteApiKeyModal = (props: Props) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const dispatch = useAppDispatch();

    const confirmAction = () => {
        const userId = props?.item.id;
        if (userId)
            dispatch(deleteKey({ userId }))
    };

    const { deletedKey } = useAppSelector(apiKeyState);

    useEffect(() => {
        if (deletedKey.isSuccess) {
            dispatch(resetDeletedKey());
            dispatch(listApiKeys());
            handleClose();
        }
    }, [deletedKey, dispatch]);

    return (
        <>
            <div onClick={handleShow}>{props?.children}</div>
            <Modal centered show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete API key</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {deletedKey.isLoading && < SmashSpinner />}
                    {!deletedKey.isLoading &&
                        <div>
                            Are you sure to delete the following API key ?
                            <p>
                                <code>{props?.item.username}</code>
                            </p>
                        </div>}

                </Modal.Body>
                {!deletedKey.isLoading && <Modal.Footer>
                    <Button onClick={handleClose} variant='light'>No</Button>
                    <Button onClick={confirmAction}>Yes</Button>
                </Modal.Footer>}
            </Modal>
        </>
    )
}

export default ConfirmDeleteApiKeyModal